import React, { useState,useRef, useEffect } from 'react';
import {
  TextField,
  Button,
  Select,
  InputLabel,
  FormControl,
  Typography,
  MenuItem,
  Box,
  Paper,
  Tab,
  Tabs,
  TextareaAutosize
} from '@mui/material';
import useApi from '../../api/useApi';
import { toast } from 'react-toastify';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router';
import { OrgCreate, ProjectCreate } from '../../api/orgService';
import SubCategorySelect from '../Admin/Consumer/SubCategorySelect';
// import { Form, TextArea } from 'semantic-ui-react'
// import { useNavigationTab } from '../../hooks/useNavigationTab';


const ProjectCreateForm = () => {


  const [form, setForm] = useState({
    name: '',
    story: '',
    location: '',
    subcategory:0,
    // owner: '',
  });

  const { user } = useAuth();
  const navigate = useNavigate()
  // const {customNavigate} = useNavigationTab()

  const { request:createProject,data:createProjectData,error:createProjectError,isLoading:createProjectIsLoading, clearHook}=useApi(ProjectCreate)


  const handleChange = (e) => {
    // setForm({ ...form, [e.target.name]: e.target.value });
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSetSubCategoryId = (subcategoryId)=>{
    // console.log(subcategoryId)
    setForm(prev => ({
      ...prev,
      subcategory: parseInt(subcategoryId)
    }));
    // console.log(form)
  }


  useEffect(()=>{
    if(createProjectData){
      if(createProjectData?.status===201){
        toast.success(`${JSON.stringify(createProjectData?.statusText)}, successful`,{position: "top-center"});
        // customNavigate("/t","","home",{refresh:"classes"})
        clearHook()
        navigate(-1,{state: {refresh:"projects",redirect:"list-projects"}})

      }
    }
  },[createProjectData])

  useEffect(()=>{
    if(createProjectError){

        toast.error(`${JSON.stringify(createProjectError?.response?.data,null,2)}`,{position: "top-center"});
    }
  },[createProjectError])

  const  okayToSubmit =  !form.name?.length>0 || !form?.story?.length>0 || !form.location?.length>0 || form.subcategory===0

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log('Material Created:', form);
    // form.created_by = user?.user?.id
    const dataToSend = {
      name: form.name,
      story: form.story,
      location: form.location,
      subcategory:form.subcategory,
      org: user?.user?.org,
    }
    // console.log(dataToSend)
    createProject(dataToSend)

    // Add API request logic here
  };
  return (
    <Box display="flex" justifyContent="center" width="100%">
    <Box display="flex" flexDirection="column" justifyContent="center" mt={4} width={700}>

        <div>
          
          <Typography variant="h5" gutterBottom>
            Create a new Project
          </Typography>
        </div>
          
          <Typography variant='p' component="p" color='#404040'>
          A project is a documentation of an activity with specific objectives in a category and subcategory where the organisation works in. 
          </Typography>
          <form onSubmit={handleSubmit} style={{marginTop:30}}>
            
          <i>Required fields are marked with an asterisk (*).</i>

            <TextField
              fullWidth
              label="Project Name"
              name="name"
              value={form.name}
              onChange={handleChange}
              margin="normal"
              required
              
            />

            <TextField
              fullWidth
              label="Location"
              name="location"
              value={form.location}
              onChange={handleChange}
              margin="normal"
              required
            />
            <Typography variant='p' component="p" color='#404040'>
            Write a story, informative description that explains about the project.
            </Typography>

            <TextField
              fullWidth
              label="story"
              name="story"
              value={form.story}
              onChange={handleChange}
              margin="normal"
              required
            />

            <SubCategorySelect setSubCategoryId={handleSetSubCategoryId}/>
           
            {/* <Form>
              <TextArea placeholder='About your organisation ...' 
              name="org_description"
              value={form?.org_description}
              onChange={handleChange} />
            </Form> */}

            {/* <Box
              width="100%"
              height="30%"
              sx={{
                pointerEvents: "none",
                color: "black",
                whiteSpace: "pre-wrap",
                padding: "16.5px 14px",
                fontFamily: "Roboto, sans-serif",
                fontSize: "1rem",
              }}
            >
              {firstPart}
              <span style={{ color: "gray" }}>{extraPart}</span>
            </Box> */}

            
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 1 ,mb:5}}
              disabled={okayToSubmit}
            >
              Create Project
            </Button>
          </form>
      </Box>
    </Box>
  );
};


export default ProjectCreateForm